// Gallery.jsx
// Drop into your src/pages/ folder.
// Matches the exact CSS token system & nav from OurCars.jsx

import { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar";
import { API, BASE_URL } from "../../api";
// const API_BASE = "http://localhost:5000/api";
// const API_BASE = "http://192.168.0.57:5000/api";
// ─── MOCK FALLBACK DATA ───────────────────────────────────────
const mockCategories = [
  { image_cat: "Fleet" },
  { image_cat: "Destinations" },
  { image_cat: "Events" },
  { image_cat: "Interiors" },
  { image_cat: "Experiences" },
];

const mockImages = {
  data: [
    { image_id:1,  image_title:"Mountain Drive",       image_category:"Destinations",  image:"https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=900&q=80", gimage_alt:"Mountain road winding through pine trees", image_sts:1, testimonial_dispinfront:1 },
    { image_id:2,  image_title:"Luxury Fleet Lineup",  image_category:"Fleet",         image:"https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=900&q=80", gimage_alt:"Row of premium cars at sunset",            image_sts:1, testimonial_dispinfront:0 },
    { image_id:3,  image_title:"Wedding Convoy",       image_category:"Events",        image:"https://images.unsplash.com/photo-1519741497674-611481863552?w=900&q=80", gimage_alt:"Decorated cars at a wedding ceremony",     image_sts:1, testimonial_dispinfront:1 },
    { image_id:4,  image_title:"Coastal Highway",      image_category:"Destinations",  image:"https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=900&q=80", gimage_alt:"Coastal highway overlooking the ocean",    image_sts:1, testimonial_dispinfront:0 },
    { image_id:5,  image_title:"Premium Interior",     image_category:"Interiors",     image:"https://images.unsplash.com/photo-1549399542-7e3f8b79c341?w=900&q=80", gimage_alt:"Leather interior of a luxury vehicle",     image_sts:1, testimonial_dispinfront:1 },
    { image_id:6,  image_title:"Night Drive",          image_category:"Experiences",   image:"https://images.unsplash.com/photo-1476357471311-43c0db9fb2b4?w=900&q=80", gimage_alt:"City lights seen from a moving car",       image_sts:1, testimonial_dispinfront:0 },
    { image_id:7,  image_title:"Desert Expedition",    image_category:"Destinations",  image:"https://images.unsplash.com/photo-1509316785289-025f5b846b35?w=900&q=80", gimage_alt:"4WD driving through sand dunes",           image_sts:1, testimonial_dispinfront:0 },
    { image_id:8,  image_title:"SUV Cockpit",          image_category:"Interiors",     image:"https://images.unsplash.com/photo-1606220838315-056192d5e927?w=900&q=80", gimage_alt:"Modern dashboard of a luxury SUV",         image_sts:1, testimonial_dispinfront:0 },
    { image_id:9,  image_title:"Corporate Event",      image_category:"Events",        image:"https://images.unsplash.com/photo-1511578314322-379afb476865?w=900&q=80", gimage_alt:"Fleet parked outside a corporate venue",   image_sts:1, testimonial_dispinfront:0 },
    { image_id:10, image_title:"Road Trip Sunrise",    image_category:"Experiences",   image:"https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?w=900&q=80", gimage_alt:"Car silhouette against a sunrise sky",     image_sts:1, testimonial_dispinfront:1 },
    { image_id:11, image_title:"EV Charging Stop",     image_category:"Experiences",   image:"https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=900&q=80", gimage_alt:"Electric vehicle charging at a station",   image_sts:1, testimonial_dispinfront:0 },
    { image_id:12, image_title:"Hillstation Escape",   image_category:"Destinations",  image:"https://images.unsplash.com/photo-1501854140801-50d01698950b?w=900&q=80", gimage_alt:"Misty hills viewed from a car window",     image_sts:1, testimonial_dispinfront:0 },
  ],
  total: 12,
};

// ─── INLINE CSS ───────────────────────────────────────────────
const css = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,900;1,700&family=DM+Sans:wght@300;400;500;600&display=swap');

  :root {
    --gold: #C9A84C;
    --gold-light: #E8C97A;
    --dark: #0A0A0F;
    --dark2: #111118;
    --dark3: #1A1A24;
    --surface: #16161F;
    --border: rgba(201,168,76,0.18);
    --text: #E8E8F0;
    --muted: #7A7A9A;
    --white: #FFFFFF;
    --radius: 12px;
  }

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  body { background: var(--dark); color: var(--text); font-family: 'DM Sans', sans-serif; }

  /* ── NAV ── */
  .gl-nav {
    position: fixed; top: 0; left: 0; right: 0; z-index: 1000;
    display: flex; align-items: center; justify-content: space-between;
    padding: 0 5%; height: 72px;
    background: rgba(10,10,15,0.96); backdrop-filter: blur(18px);
    border-bottom: 1px solid var(--border);
  }
  .gl-nav-logo { font-family: 'Playfair Display', serif; font-size: 1.6rem; color: var(--gold); letter-spacing: -0.5px; cursor: pointer; }
  .gl-nav-logo span { color: var(--white); }
  .gl-nav-links { display: flex; gap: 2rem; list-style: none; }
  .gl-nav-links a { color: var(--muted); text-decoration: none; font-size: .9rem; font-weight: 500; letter-spacing: .5px; transition: color .2s; }
  .gl-nav-links a:hover, .gl-nav-links a.active { color: var(--gold); }
  .gl-nav-cta { background: var(--gold); color: var(--dark); font-weight: 600; font-size: .85rem; padding: .55rem 1.4rem; border: none; border-radius: 8px; cursor: pointer; transition: background .2s; }
  .gl-nav-cta:hover { background: var(--gold-light); }
  .gl-mobile-toggle { display: none; flex-direction: column; gap: 5px; cursor: pointer; background: none; border: none; padding: 4px; }
  .gl-mobile-toggle span { display: block; width: 24px; height: 2px; background: var(--gold); border-radius: 2px; transition: all .3s; }
  .gl-mobile-menu {
    display: none; position: fixed; top: 72px; left: 0; right: 0; z-index: 999;
    background: rgba(10,10,15,0.98); backdrop-filter: blur(18px);
    border-bottom: 1px solid var(--border); padding: 1.5rem 5%; flex-direction: column;
  }
  .gl-mobile-menu.open { display: flex; }
  .gl-mobile-menu a { color: var(--muted); text-decoration: none; font-size: 1rem; font-weight: 500; padding: .9rem 0; border-bottom: 1px solid var(--border); display: block; transition: color .2s; }
  .gl-mobile-menu a:hover { color: var(--gold); }
  .gl-mobile-menu .gl-nav-cta { margin-top: 1rem; width: 100%; text-align: center; padding: .7rem; font-size: .95rem; }

  /* ── HERO ── */
  .gl-hero {
    padding: 130px 5% 70px;
    background: var(--dark2);
    border-bottom: 1px solid var(--border);
    position: relative; overflow: hidden;
  }
  .gl-hero::before {
    content: ''; position: absolute; inset: 0;
    background: radial-gradient(ellipse 50% 100% at 80% 60%, rgba(201,168,76,.09) 0%, transparent 65%);
    pointer-events: none;
  }
  .gl-hero-inner { position: relative; max-width: 640px; }
  .gl-hero-label { font-size: .72rem; letter-spacing: 3px; text-transform: uppercase; color: var(--gold); margin-bottom: .8rem; }
  .gl-hero-title { font-family: 'Playfair Display', serif; font-size: clamp(2.2rem, 5vw, 4rem); color: var(--white); line-height: 1.08; margin-bottom: 1rem; }
  .gl-hero-title em { color: var(--gold); font-style: italic; }
  .gl-hero-desc { color: var(--muted); font-size: .95rem; line-height: 1.75; }

  /* ── TOOLBAR ── */
  .gl-toolbar {
    position: sticky; top: 72px; z-index: 100;
    background: rgba(10,10,15,0.95); backdrop-filter: blur(16px);
    border-bottom: 1px solid var(--border);
    padding: 1rem 5%;
    display: flex; align-items: center; gap: 1rem; flex-wrap: wrap;
  }
  .gl-search-wrap { position: relative; flex: 1; min-width: 220px; max-width: 380px; }
  .gl-search-wrap svg { position: absolute; left: .9rem; top: 50%; transform: translateY(-50%); color: var(--muted); pointer-events: none; }
  .gl-search {
    width: 100%; padding: .6rem 1rem .6rem 2.5rem;
    background: var(--surface); border: 1px solid var(--border);
    border-radius: 10px; color: var(--text); font-size: .88rem; font-family: inherit;
    outline: none; transition: border-color .2s;
  }
  .gl-search:focus { border-color: var(--gold); }
  .gl-search::placeholder { color: var(--muted); }
  .gl-cats { display: flex; gap: .5rem; flex-wrap: wrap; flex: 1; }
  .gl-cat-btn {
    padding: .45rem 1rem; border-radius: 20px; font-size: .8rem; font-weight: 600;
    cursor: pointer; border: 1px solid var(--border); background: var(--surface); color: var(--muted);
    transition: all .2s; white-space: nowrap; font-family: inherit;
  }
  .gl-cat-btn:hover { border-color: var(--gold); color: var(--gold); }
  .gl-cat-btn.active { background: var(--gold); color: var(--dark); border-color: var(--gold); }
  .gl-view-toggle { display: flex; gap: .4rem; margin-left: auto; }
  .gl-view-btn {
    width: 36px; height: 36px; border-radius: 8px; border: 1px solid var(--border);
    background: var(--surface); color: var(--muted); cursor: pointer;
    display: flex; align-items: center; justify-content: center; transition: all .2s;
  }
  .gl-view-btn.active, .gl-view-btn:hover { border-color: var(--gold); color: var(--gold); }
  .gl-count-pill {
    font-size: .78rem; color: var(--muted); white-space: nowrap;
    background: var(--surface); border: 1px solid var(--border); border-radius: 20px; padding: .35rem .85rem;
  }
  .gl-count-pill strong { color: var(--gold); }

  /* ── GALLERY BODY ── */
  .gl-body { padding: 2.5rem 5% 5rem; }

  /* ── MASONRY (default) ── */
  .gl-masonry {
    columns: 4; column-gap: 1.2rem;
  }
  .gl-masonry-item {
    break-inside: avoid; margin-bottom: 1.2rem;
    border-radius: 14px; overflow: hidden; cursor: pointer;
    border: 1px solid transparent; position: relative;
    transition: border-color .3s, transform .3s, box-shadow .3s;
  }
  .gl-masonry-item:hover {
    border-color: var(--gold); transform: translateY(-4px);
    box-shadow: 0 20px 50px rgba(0,0,0,.5);
  }
  .gl-masonry-item img { width: 100%; height: auto; display: block; transition: transform .5s ease; }
  .gl-masonry-item:hover img { transform: scale(1.04); }

  /* ── GRID (uniform) ── */
  .gl-grid {
    display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 1.2rem;
  }
  .gl-grid-item {
    border-radius: 14px; overflow: hidden; cursor: pointer; position: relative;
    border: 1px solid transparent; aspect-ratio: 4/3;
    transition: border-color .3s, transform .3s, box-shadow .3s;
  }
  .gl-grid-item:hover {
    border-color: var(--gold); transform: translateY(-4px);
    box-shadow: 0 20px 50px rgba(0,0,0,.5);
  }
  .gl-grid-item img { width: 100%; height: 100%; object-fit: cover; transition: transform .5s ease; display: block; }
  .gl-grid-item:hover img { transform: scale(1.06); }

  /* ── OVERLAY CAPTION (both modes) ── */
  .gl-overlay {
    position: absolute; bottom: 0; left: 0; right: 0;
    background: linear-gradient(to top, rgba(10,10,15,.9) 0%, transparent 100%);
    padding: 2rem 1.1rem .9rem;
    opacity: 0; transform: translateY(6px);
    transition: opacity .3s, transform .3s;
    pointer-events: none;
  }
  .gl-masonry-item:hover .gl-overlay,
  .gl-grid-item:hover .gl-overlay { opacity: 1; transform: translateY(0); }
  .gl-overlay-cat { font-size: .68rem; letter-spacing: 1.8px; text-transform: uppercase; color: var(--gold); font-weight: 600; margin-bottom: .3rem; }
  .gl-overlay-title { font-family: 'Playfair Display', serif; font-size: 1rem; color: var(--white); line-height: 1.25; }
  .gl-overlay-expand {
    position: absolute; top: .8rem; right: .8rem;
    width: 32px; height: 32px; border-radius: 8px;
    background: rgba(201,168,76,.9); border: none; cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    opacity: 0; transform: scale(.8);
    transition: opacity .25s, transform .25s;
  }
  .gl-masonry-item:hover .gl-overlay-expand,
  .gl-grid-item:hover .gl-overlay-expand { opacity: 1; transform: scale(1); }

  /* ── HOMEPAGE BADGE ── */
  .gl-home-badge {
    position: absolute; top: .7rem; left: .7rem;
    background: var(--gold); color: var(--dark); font-size: .65rem; font-weight: 700;
    padding: .25rem .65rem; border-radius: 20px; letter-spacing: .5px; text-transform: uppercase;
  }

  /* ── LIGHTBOX ── */
  .gl-lb-bg {
    position: fixed; inset: 0; z-index: 3000;
    background: rgba(5,5,10,.96); backdrop-filter: blur(20px);
    display: flex; align-items: center; justify-content: center;
    animation: glFadeIn .25s ease;
  }
  @keyframes glFadeIn { from{opacity:0} to{opacity:1} }

  .gl-lb-wrap {
    position: relative; max-width: 1100px; width: 96%;
    display: flex; flex-direction: column; align-items: center;
    animation: glSlideUp .3s ease;
  }
  @keyframes glSlideUp { from{opacity:0;transform:translateY(28px)} to{opacity:1;transform:translateY(0)} }

  .gl-lb-img-area {
    position: relative; width: 100%;
    border-radius: 18px; overflow: hidden;
    border: 1px solid var(--border);
    box-shadow: 0 40px 100px rgba(0,0,0,.7);
    max-height: 75vh; display: flex; align-items: center; justify-content: center;
    background: var(--dark3);
  }
  .gl-lb-img-area img {
    max-width: 100%; max-height: 75vh;
    width: auto; height: auto; display: block;
    object-fit: contain;
  }

  .gl-lb-close {
    position: absolute; top: 1rem; right: 1rem; z-index: 10;
    width: 40px; height: 40px; border-radius: 50%;
    background: var(--surface); border: 1px solid var(--border);
    color: var(--muted); font-size: 1.2rem; cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    transition: all .2s;
  }
  .gl-lb-close:hover { background: var(--gold); color: var(--dark); border-color: var(--gold); }

  .gl-lb-arrow {
    position: absolute; top: 50%; transform: translateY(-50%);
    width: 48px; height: 48px; border-radius: 50%;
    background: rgba(22,22,31,.85); border: 1px solid var(--border);
    color: var(--text); font-size: 1.4rem; cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    transition: all .2s; z-index: 10;
  }
  .gl-lb-arrow:hover { background: var(--gold); color: var(--dark); border-color: var(--gold); }
  .gl-lb-arrow.prev { left: 5px; }
  .gl-lb-arrow.next { right: 5px; }

  .gl-lb-meta {
    margin-top: 1.2rem; display: flex; flex-direction: column; align-items: center; gap: .3rem;
    text-align: center;
  }
  .gl-lb-cat { font-size: .72rem; letter-spacing: 2px; text-transform: uppercase; color: var(--gold); font-weight: 600; }
  .gl-lb-title { font-family: 'Playfair Display', serif; font-size: 1.25rem; color: var(--white); }
  .gl-lb-counter { font-size: .8rem; color: var(--muted); margin-top: .2rem; }
  .gl-lb-dots { display: flex; gap: .4rem; margin-top: .8rem; justify-content: center; }
  .gl-lb-dot {
    width: 6px; height: 6px; border-radius: 50%; border: none; cursor: pointer;
    background: var(--muted); transition: all .2s; padding: 0;
  }
  .gl-lb-dot.active { background: var(--gold); width: 18px; border-radius: 3px; }

  /* ── LOAD MORE ── */
  .gl-load-more-wrap { text-align: center; margin-top: 3rem; }
  .gl-load-more {
    background: transparent; border: 1px solid var(--gold); color: var(--gold);
    padding: .75rem 2.5rem; border-radius: 10px; font-size: .9rem; font-weight: 600;
    cursor: pointer; font-family: inherit; transition: all .25s;
  }
  .gl-load-more:hover { background: var(--gold); color: var(--dark); transform: translateY(-2px); box-shadow: 0 10px 30px rgba(201,168,76,.25); }
  .gl-load-more:disabled { opacity: .4; cursor: not-allowed; transform: none; box-shadow: none; }

  /* ── EMPTY ── */
  .gl-empty { text-align: center; padding: 6rem 2rem; color: var(--muted); }
  .gl-empty-icon { font-size: 3rem; margin-bottom: 1rem; opacity: .4; }
  .gl-empty h3 { font-family: 'Playfair Display', serif; font-size: 1.5rem; color: var(--white); margin-bottom: .5rem; }

  /* ── SKELETON ── */
  .gl-skeleton-grid {
    display: grid; grid-template-columns: repeat(auto-fill, minmax(280px,1fr)); gap: 1.2rem;
  }
  .gl-skeleton-item {
    border-radius: 14px; overflow: hidden; aspect-ratio: 4/3;
    background: linear-gradient(90deg, var(--surface) 25%, var(--dark3) 50%, var(--surface) 75%);
    background-size: 200% 100%; animation: glShimmer 1.5s infinite;
  }
  @keyframes glShimmer { 0%{background-position:200% 0} 100%{background-position:-200% 0} }

  /* ── RESPONSIVE ── */
  @media (max-width: 1100px) { .gl-masonry { columns: 3; } }
  @media (max-width: 768px) {
    .gl-nav-links, .gl-nav-cta { display: none; }
    .gl-mobile-toggle { display: flex; }
    .gl-masonry { columns: 2; }
    .gl-toolbar { padding: .85rem 4%; gap: .75rem; }
    .gl-body { padding: 2rem 4% 4rem; }
    .gl-hero { padding: 100px 4% 50px; }
    .gl-lb-arrow.prev { left: 4px; }
    .gl-lb-arrow.next { right: 4px; }
    .gl-lb-arrow { width: 38px; height: 38px; font-size: 1.1rem; }
  }
  @media (max-width: 480px) {
    .gl-masonry { columns: 1; }
    .gl-grid { grid-template-columns: 1fr; }
    .gl-lb-title { font-size: 1rem; }
  }
`;

// ─── HELPERS ──────────────────────────────────────────────────
const getImg = (img) => {
  if (!img || img === "" || img === "default.jpg")
    return "https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=900&q=80";
  if (img.startsWith("http")) return img;
  // return `${API_BASE.replace("/api", "")}/${img}`;
  return `${BASE_URL}/${img}`;
};

// ─── NAVBAR ──────────────────────────────────────────────────
// function GlNavbar({ siteName }) {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const navigate = useNavigate();
//   const links = [
//     { label: "Home", path: "/" },
//     { label: "Fleet", path: "/our-cars" },
//     { label: 'Modify Reservation', href: '/modify-reservetion' },
//     { label: "Gallery", path: "/gallery" },
//     { label: "About", path: "/about-us" },
//     { label: "Faq", path: "/faqs" },
//     { label: "Contact", path: "/contact-us" },
//   ];
//   return (
//     <>
//       <nav className="gl-nav">
//         <div className="gl-nav-logo" onClick={() => navigate("/")}>
//           Orisnz<span>{siteName?.replace("Drive", "") || "-Fleet"}</span>
//         </div>
//         <ul className="gl-nav-links">
//           {links.map(item => (
//             <li key={item.label}>
//               <a href={item.path} className={item.label === "Gallery" ? "active" : ""}
//                 onClick={e => { e.preventDefault(); navigate(item.path); }}>
//                 {item.label}
//               </a>
//             </li>
//           ))}
//         </ul>
//         <button className="gl-nav-cta" onClick={() => navigate("/#bknengine")}>Book Now</button>
//         <button className="gl-mobile-toggle" onClick={() => setMenuOpen(o => !o)} aria-label="Toggle menu">
//           <span style={menuOpen ? { transform: "rotate(45deg) translate(5px,5px)" } : {}} />
//           <span style={menuOpen ? { opacity: 0 } : {}} />
//           <span style={menuOpen ? { transform: "rotate(-45deg) translate(5px,-5px)" } : {}} />
//         </button>
//       </nav>
//       <div className={`gl-mobile-menu${menuOpen ? " open" : ""}`}>
//         {links.map(item => (
//           <a key={item.label} href={item.path}
//             onClick={e => { e.preventDefault(); navigate(item.path); setMenuOpen(false); }}>
//             {item.label}
//           </a>
//         ))}
//         <button className="gl-nav-cta" onClick={() => { setMenuOpen(false); navigate("/#bknengine"); }}>Book Now</button>
//       </div>
//     </>
//   );
// }

// ─── LIGHTBOX ─────────────────────────────────────────────────
function Lightbox({ images, startIndex, onClose }) {
  const [idx, setIdx] = useState(startIndex);
  const cur = images[idx];
  const total = images.length;

  const prev = useCallback(() => setIdx(i => (i - 1 + total) % total), [total]);
  const next = useCallback(() => setIdx(i => (i + 1) % total), [total]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "ArrowLeft") prev();
      else if (e.key === "ArrowRight") next();
      else if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [prev, next, onClose]);

  if (!cur) return null;

  // Show at most 7 dot indicators centered around current
  const dotRange = 7;
  const half = Math.floor(dotRange / 2);
  const startDot = Math.max(0, Math.min(idx - half, total - dotRange));
  const endDot = Math.min(total, startDot + dotRange);
  const dots = Array.from({ length: endDot - startDot }, (_, i) => startDot + i);

  return (
    <div className="gl-lb-bg" onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="gl-lb-wrap">
        <div className="gl-lb-img-area">
          <button className="gl-lb-close" onClick={onClose}>×</button>
          {total > 1 && (
            <>
              <button className="gl-lb-arrow prev" onClick={prev}>‹</button>
              <button className="gl-lb-arrow next" onClick={next}>›</button>
            </>
          )}
          <img src={getImg(cur.image)} alt={cur.gimage_alt || cur.image_title} />
        </div>
        <div className="gl-lb-meta">
          <div className="gl-lb-cat">{cur.image_category}</div>
          <div className="gl-lb-title">{cur.image_title}</div>
          <div className="gl-lb-counter">{idx + 1} / {total}</div>
          {total > 1 && (
            <div className="gl-lb-dots">
              {dots.map(d => (
                <button key={d} className={`gl-lb-dot${d === idx ? " active" : ""}`} onClick={() => setIdx(d)} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ─── EXPAND ICON ─────────────────────────────────────────────
const ExpandIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/>
  </svg>
);

const SearchIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
  </svg>
);

// Grid view icon
const GridIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
    <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
  </svg>
);

// Masonry view icon
const MasonryIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="11"/><rect x="14" y="3" width="7" height="7"/>
    <rect x="14" y="14" width="7" height="7"/><rect x="3" y="18" width="7" height="3"/>
  </svg>
);

// ─── GALLERY CARD ─────────────────────────────────────────────
function GalleryCard({ img, mode, onClick }) {
  const Component = mode === "masonry" ? "div" : "div";
  const cls = mode === "masonry" ? "gl-masonry-item" : "gl-grid-item";
  return (
    <div className={cls} onClick={onClick}>
      <img src={getImg(img.image)} alt={img.gimage_alt || img.image_title} loading="lazy" />
      {img.testimonial_dispinfront === 1 && <div className="gl-home-badge">★ Featured</div>}
      <div className="gl-overlay">
        <div className="gl-overlay-cat">{img.image_category}</div>
        <div className="gl-overlay-title">{img.image_title}</div>
      </div>
      <button className="gl-overlay-expand" onClick={e => { e.stopPropagation(); onClick(); }}>
        <ExpandIcon />
      </button>
    </div>
  );
}

// ─── MAIN PAGE ────────────────────────────────────────────────
const PAGE_SIZE = 12;

export default function Gallery() {
  const [categories, setCategories] = useState([]);
  const [images, setImages]         = useState([]);
  const [total, setTotal]           = useState(0);
  const [loading, setLoading]       = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [page, setPage]             = useState(1);

  const [search, setSearch]         = useState("");
  const [activeSearch, setActiveSearch] = useState(""); // debounced
  const [category, setCategory]     = useState("all");
  const [viewMode, setViewMode]     = useState("masonry"); // masonry | grid

  const [lightbox, setLightbox]     = useState({ open: false, idx: 0 });
  const [settings, setSettings]     = useState({});
  const [menuOpen, setMenuOpen]     = useState(false);
  const navigate = useNavigate();
  const searchTimer = useRef(null);

  // Debounce search input
  const handleSearchChange = (val) => {
    setSearch(val);
    clearTimeout(searchTimer.current);
    searchTimer.current = setTimeout(() => {
      setActiveSearch(val);
      setPage(1);
      setImages([]);
    }, 420);
  };

  // Fetch settings
  useEffect(() => {
    // fetch(`${API_BASE}/settings`)
    //   .then(r => r.json())
    //   .then(d => setSettings(d || {}))
    //   .catch(() => {});
    API.get("/settings")
  .then(r => setSettings(r.data || {}))
  .catch(() => {});
  }, []);

  // Fetch categories
  useEffect(() => {
    // fetch(`${API_BASE}/gallery/categories`)
    //   .then(r => r.json())
    //   .then(d => setCategories(Array.isArray(d) ? d : []))
    //   .catch(() => setCategories(mockCategories));
    API.get("/gallery/categories")
  .then(r => setCategories(Array.isArray(r.data) ? r.data : []))
  .catch(() => setCategories(mockCategories));
  }, []);

  // Fetch images
  const fetchImages = useCallback((pg, cat, srch, append = false) => {
    if (pg === 1 && !append) setLoading(true);
    else setLoadingMore(true);

    const params = new URLSearchParams({
      page: pg, limit: PAGE_SIZE,
      status: "1",
      ...(cat !== "all" && { category: cat }),
      ...(srch && { search: srch }),
    });

    // fetch(`${API_BASE}/gallery?${params}`)
    //   .then(r => r.json())
    //   .then(d => {
    //     const rows = Array.isArray(d?.data) ? d.data : Array.isArray(d) ? d : mockImages.data;
    //     const tot  = d?.total ?? rows.length;
    //     setImages(prev => append ? [...prev, ...rows] : rows);
    //     setTotal(tot);
    //   })
    //   .catch(() => {
    //     if (!append) setImages(mockImages.data);
    //     setTotal(mockImages.total);
    //   })
    //   .finally(() => { setLoading(false); setLoadingMore(false); });
    API.get(`/gallery?${params}`)
  .then(r => {
    const d    = r.data;
    const rows = Array.isArray(d?.data) ? d.data : Array.isArray(d) ? d : mockImages.data;
    const tot  = d?.total ?? rows.length;
    setImages(prev => append ? [...prev, ...rows] : rows);
    setTotal(tot);
  })
  .catch(() => {
    if (!append) setImages(mockImages.data);
    setTotal(mockImages.total);
  })
  .finally(() => { setLoading(false); setLoadingMore(false); });
  }, []);

  useEffect(() => {
    setPage(1);
    setImages([]);
    fetchImages(1, category, activeSearch, false);
  }, [category, activeSearch, fetchImages]);

  const handleLoadMore = () => {
    const next = page + 1;
    setPage(next);
    fetchImages(next, category, activeSearch, true);
  };

  const handleCatChange = (cat) => {
    setCategory(cat);
    setPage(1);
    setImages([]);
  };

  const hasMore = images.length < total;
  const catOptions = ["all", ...categories.map(c => c.image_cat).filter(Boolean)];

  return (
    <>
      <style>{css}</style>
      {/* <GlNavbar siteName={settings?.site_name} /> */}
      <Navbar activePage="Gallery" siteName={settings?.site_name} />
      {/* ── HERO ── */}
      <div className="gl-hero">
        <div className="gl-hero-inner">
          <div className="gl-hero-label">Our Journey in Pictures</div>
          <h1 className="gl-hero-title">The <em>Gallery</em></h1>
          <p className="gl-hero-desc">
            Moments captured — from scenic mountain routes to premium fleet lineups.
            Browse our collection of journeys, experiences, and the vehicles that made them unforgettable.
          </p>
        </div>
      </div>

      {/* ── STICKY TOOLBAR ── */}
      <div className="gl-toolbar">
        {/* Search */}
        <div className="gl-search-wrap">
          <SearchIcon />
          <input
            className="gl-search"
            placeholder="Search images…"
            value={search}
            onChange={e => handleSearchChange(e.target.value)}
          />
        </div>

        {/* Category pills */}
        <div className="gl-cats">
          {catOptions.map(cat => (
            <button
              key={cat}
              className={`gl-cat-btn${category === cat ? " active" : ""}`}
              onClick={() => handleCatChange(cat)}
            >
              {cat === "all" ? "All" : cat}
            </button>
          ))}
        </div>

        {/* Count pill */}
        <div className="gl-count-pill">
          <strong>{total}</strong> photos
        </div>

        {/* View toggle */}
        <div className="gl-view-toggle">
          <button className={`gl-view-btn${viewMode === "masonry" ? " active" : ""}`} onClick={() => setViewMode("masonry")} title="Masonry view">
            <MasonryIcon />
          </button>
          <button className={`gl-view-btn${viewMode === "grid" ? " active" : ""}`} onClick={() => setViewMode("grid")} title="Grid view">
            <GridIcon />
          </button>
        </div>
      </div>

      {/* ── GALLERY BODY ── */}
      <div className="gl-body">
        {loading ? (
          <div className="gl-skeleton-grid">
            {Array.from({ length: PAGE_SIZE }).map((_, i) => (
              <div key={i} className="gl-skeleton-item" style={{ animationDelay: `${i * 0.04}s` }} />
            ))}
          </div>
        ) : images.length === 0 ? (
          <div className="gl-empty">
            <div className="gl-empty-icon">🖼️</div>
            <h3>No Images Found</h3>
            <p>Try a different category or clear your search.</p>
            <button
              onClick={() => { handleSearchChange(""); handleCatChange("all"); }}
              style={{ marginTop: "1.5rem", background: "var(--gold)", color: "var(--dark)", fontWeight: 700, padding: ".65rem 1.8rem", border: "none", borderRadius: "8px", cursor: "pointer", fontSize: ".9rem" }}
            >
              Reset Filters
            </button>
          </div>
        ) : viewMode === "masonry" ? (
          <div className="gl-masonry">
            {images.map((img, i) => (
              <GalleryCard key={img.image_id} img={img} mode="masonry" onClick={() => setLightbox({ open: true, idx: i })} />
            ))}
          </div>
        ) : (
          <div className="gl-grid">
            {images.map((img, i) => (
              <GalleryCard key={img.image_id} img={img} mode="grid" onClick={() => setLightbox({ open: true, idx: i })} />
            ))}
          </div>
        )}

        {/* ── LOAD MORE ── */}
        {!loading && hasMore && (
          <div className="gl-load-more-wrap">
            <button className="gl-load-more" onClick={handleLoadMore} disabled={loadingMore}>
              {loadingMore ? "Loading…" : `Load More  ·  ${total - images.length} remaining`}
            </button>
          </div>
        )}
      </div>

      {/* ── LIGHTBOX ── */}
      {lightbox.open && (
        <Lightbox
          images={images}
          startIndex={lightbox.idx}
          onClose={() => setLightbox({ open: false, idx: 0 })}
        />
      )}
    </>
  );
}